import * as DateF from 'date-fns'
import { useMemo } from 'react'
import styled from 'styled-components'

import { Tooltip } from '@blade/ui-kit'
import { DATE_FORMAT } from '@root/shared'
import { useFormatDuration } from '@root/shared'
import { useCurrentDate } from '@root/shared/lib/react'

import type { LimitOrderModel } from '@root/entities/limit-order'
import type { ClassNameProps } from '@root/shared/lib/react'

type Props = {
  order: LimitOrderModel
} & ClassNameProps

export const OrdersTableExpiryCell: React.FC<Props> = ({
  className,
  order,
}) => {
  const currentDate = useCurrentDate({ updateInterval: 'second' })
  const { formatDuration } = useFormatDuration()

  const expirationFormatted = useMemo(
    () =>
      formatDuration({
        startAt: currentDate,
        endAt: order.deadlineAt,
        mode: 'unitsShort',
      }),
    [currentDate, formatDuration, order.deadlineAt],
  )

  return (
    <Tooltip content={DateF.format(new Date(), DATE_FORMAT.dd_MM_yy__HH_mm)}>
      <Root className={className}>
        {order.deadlineAt > currentDate
          ? expirationFormatted
          : DateF.format(order.deadlineAt, DATE_FORMAT.dd_MM_yy__HH_mm)}
      </Root>
    </Tooltip>
  )
}

const Root = styled.div`
  color: var(--text-11);

  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`
